import React from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {useParams} from 'react-router-dom';
import CreateFromHistorySingleVoyage
    from "@containers/singleVoyage/mutateVoyage/createFromHistoryVoyage/CreateFromHistorySingleVoyage";

const CreateFromHistorySingleVoyagePage = () => {
    const {voyageId} = useParams()
    return (
        <PageLayout>
            <CreateFromHistorySingleVoyage
                voyageId={voyageId}
            />
        </PageLayout>
    );
};

export default CreateFromHistorySingleVoyagePage;